import React from 'react';

const DataRetention: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="bg-[#B3D9E6]/10 p-4 rounded-lg mb-6">
        <p className="font-semibold text-gray-800">Data Protection Commitment:</p>
        <p>We are committed to protecting your data and providing you with control over your information.</p>
      </div>

      <h4 className="text-lg font-semibold mb-2">Data Storage Period</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Active account data retained throughout subscription period</li>
        <li>Conversation history kept for 12 months by default</li>
        <li>Account metadata retained for legal compliance (7 years)</li>
        <li>Anonymized analytics data kept indefinitely</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Data Deletion Options</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Manual conversation deletion available anytime</li>
        <li>Bulk deletion tools in account settings</li>
        <li>Complete account deletion on request</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Data Access</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Access your conversations through the platform interface</li>
        <li>View your account information in settings</li>
        <li>Contact support for specific data inquiries</li>
      </ul>

      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          Note: Some data may be retained for legal compliance even after account deletion. 
          This typically includes transaction records and security logs.
        </p>
      </div>
    </div>
  );
};

export default DataRetention;